import {ArtfactKind} from '@mrp-brasil/nick-data-commons';
import {Hook, HookClass, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import {interval, Observable, of} from 'rxjs';
import {delay, map} from 'rxjs/operators';

@HookClass('event.interval')
export class EventIntervalHook {

    @Hook('77cb1ef7-5485-4a5a-a524-eea284caccb6')
    public interval(args: NickProcessArtfact): Observable<NickProcessArtfact> {
        return interval(args.object.config.delay)
            .pipe(map((index: any) => {
                const artifact = new NickProcessArtfact();
                artifact.kind = ArtfactKind.ANY;
                artifact.object = index;
                return artifact;
            }));
    }

    @Hook('be1a3364-c325-4088-98b9-ff7ca6342ee1')
    public delay(args: NickProcessArtfact): Observable<NickProcessArtfact> {
        const artifact = new NickProcessArtfact();
        artifact.kind = ArtfactKind.ANY;
        artifact.object = args.object.config.delay;
        return of(artifact)
            .pipe(delay(args.object.config.delay));
    }
}
